import _, { isObject } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { myTasksDepartmentsListName, myTasksDependListName, myTasksLocationsListName, myTasksRegionsListName } from "src/api/config/myTasksLists.config";
import Form from "src/components/Form";
import Loading from "src/components/Loading";
import { SearchUI } from "src/components/ui/Search";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import ExportToExcel from "src/modules/exelExport";
import { getItemsRequest } from "src/modules/spItems/api";
import { selectItems } from "src/modules/spItems/selectors";
import { addUsers } from "src/modules/users/actions";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import { RootState } from "src/store/rootReducer";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { myTasksIncidentsQuestionsListName, myTasksIncidentsStatusesListName, myTasksIncidentstListName, myTasksIncidentstWithRelationsListName, myTasksTypeIncidentsListName } from "src/api/config/myTasksInc.config";
import LoadingOpBg from "src/components/LoadingOpBg";
import AddSecurity from "../addSecurity";
import MyTasksSecurityTable from "src/components/tables/MyTasksSecurityTable";
import IncidentsSecurityIcon from "src/components/ui-icons/menu/IncidentsSecurityIcon";
import { actionsStatus, incTypes } from "src/api/config/systemSwitch";
import { FavoriteButtonFilters } from "src/modules/favoriteFilters/mt/FavoriteButtonFilters";
import { FavoriteFiltersList } from "src/modules/favoriteFilters/mt/FavoriteFiltersList";

function IncidentsFilters({ searchQuery, setFilters, setSearchQuery, setGegIncidents, filters, setLocalFilters, setFieldsFromExel, setDisplayFilters, filtersParams, setFiltersParams, defaultUserFilter, userFilterCheck, reRenderUserFilter }: any) {
    const [defaultValues, setDefaultValues] = useState();
    const [incQuestions, setIncQuestions] = useState<any>([]);
    const [fields, setFields] = useState<any>([]);
    const [incidentsFilter, setIncidentsFilter] = useState<any>(null);
    const [renderInc, setRenderInc] = useState(false);

    const collections: any = useAppSelector((state) => selectItems(state, myTasksLocationsListName));
    const departments: any = useAppSelector((state) => selectItems(state, myTasksDepartmentsListName));
    const sectors: any = useAppSelector((state) => selectItems(state, myTasksRegionsListName));
    const statuses: any = useAppSelector((state) => selectItems(state, myTasksIncidentsStatusesListName));
    const [currentTypeInc, setCurrentTypeInc] = useState<any>('Security');
    const [dependenceFields, setDependenceFields] = useState<any>({
        Location: null,
        Department: null,
        Region: null
    });
    const dispatch = useAppDispatch();
    const [customLoading, setCustomLoading] = useState(true);
    const [resetFilters, setResetFiters] = useState(false);
    const [incKeys, setIncKeys] = useState<any>([]);
    const currentUser = useAppSelector((state) => selectCurrentUser(state));

    useEffect(() => {
        if (renderInc) {
            setCustomLoading(true);
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]['key'] === 'Location') {
                    tempFieldsForm[i]['optionsInputs'] = collections.map((collection: any) => {
                        return {
                            id: collection.ID,
                            name: collection.Title,
                            disabled: false
                        }
                    })
                }
                if (tempFieldsForm[i]['key'] === 'Department') {
                    tempFieldsForm[i]['optionsInputs'] = departments.map((department: any) => {
                        return {
                            id: department.ID,
                            name: department.Title,
                            disabled: false
                        }
                    })
                }
                if (tempFieldsForm[i]['key'] === 'Region') {
                    tempFieldsForm[i]['optionsInputs'] = sectors.map((sector: any) => {
                        return {
                            id: sector.ID,
                            name: sector.Title,
                            disabled: false
                        }
                    })
                }
                if (tempFieldsForm[i]['key'] === 'Status') {
                    tempFieldsForm[i]['optionsInputs'] = statuses.map((status: any) => {
                        return {
                            id: status.ID,
                            name: status.Title,
                            disabled: false
                        }
                    })
                }
            }
            setFields([...tempFieldsForm]);
            setCustomLoading(false);
        }
    }, [collections, departments, sectors, renderInc, statuses]);

    useEffect(() => {
        if (renderInc) {
            setCustomLoading(true);
            let filtersDependDocuments: any = {};
            const tempFieldsForm = [...fields];
            Object.keys(dependenceFields).map(key => {
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]['key'] === key) {
                        tempFieldsForm[i]['optionsInputs'] = tempFieldsForm[i]['optionsInputs'].map((option: any) => {
                            return {
                                id: option.id,
                                name: option.name,
                                disabled: false
                            }
                        })
                    }
                }
            });
            Object.keys(dependenceFields).map(key => {
                if (dependenceFields[key] && dependenceFields[key].length > 0) {
                    filtersDependDocuments[key] = dependenceFields[key].map((item: any) => item.id);
                }
            });
            if (Object.keys(filtersDependDocuments).length === 0) {
                setFields([...tempFieldsForm]);
                setCustomLoading(false);
            } else {
                if (Object.keys(filtersDependDocuments).length > 0) {
                    //Устанавливаем зависимости в фильтрах 
                    getItemsRequest({ listName: myTasksDependListName, filters: filtersDependDocuments, filtersType: "or" }).then(results => {
                        const dependDocuments = [...results.items];
                        const collectionIds = _.uniqWith(dependDocuments.map((item: any) => item.Location.get_lookupId()), _.isEqual);
                        const departmentIds = _.uniqWith(dependDocuments.map((item: any) => item.Departament.get_lookupId()), _.isEqual);
                        const sectorIds = _.uniqWith(dependDocuments.map((item: any) => item.Region.get_lookupId()), _.isEqual);
                        for (let i = 0; i < tempFieldsForm.length; i++) {
                            if (tempFieldsForm[i]['key'] === 'Location') {
                                if (!filtersDependDocuments['Location'] || Object.keys(filtersDependDocuments).length > 1) {
                                    tempFieldsForm[i]['optionsInputs'] = collections.map((collection: any) => {
                                        return {
                                            id: collection.ID,
                                            name: collection.Title,
                                            disabled: false, // collectionIds.indexOf(collection.ID) === -1,
                                            hide: collectionIds.indexOf(collection.ID) === -1
                                        }
                                    })
                                }
                            }
                            if (tempFieldsForm[i]['key'] === 'Department') {
                                if (!filtersDependDocuments['Department'] || Object.keys(filtersDependDocuments).length > 1) {
                                    tempFieldsForm[i]['optionsInputs'] = departments.map((department: any) => {
                                        return {
                                            id: department.ID,
                                            name: department.Title,
                                            disabled: false, // departmentIds.indexOf(department.ID) === -1,
                                            hide: departmentIds.indexOf(department.ID) === -1
                                        }
                                    })
                                }
                            }
                            if (tempFieldsForm[i]['key'] === 'Region') {
                                if (!filtersDependDocuments['Region'] || Object.keys(filtersDependDocuments).length > 1) {
                                    tempFieldsForm[i]['optionsInputs'] = sectors.map((sector: any) => {
                                        return {
                                            id: sector.ID,
                                            name: sector.Title,
                                            disabled: false, // sectorIds.indexOf(sector.ID) === -1,
                                            hide: sectorIds.indexOf(sector.ID) === -1
                                        }
                                    })
                                }
                            }
                        }
                        setFields([...tempFieldsForm]);
                        setCustomLoading(false);
                    });
                }
            }
        }
    }, [dependenceFields, renderInc]);

    useEffect(() => {
        if (incQuestions.length > 0) {
            setFieldsFromExel([...incQuestions]);
            setFields([...incQuestions]);
            setRenderInc(true);
            setCustomLoading(false);
        }
    }, [incQuestions]);

    useEffect(() => {
        if (currentTypeInc) {
            setCustomLoading(true);
            getItemsRequest({ listName: myTasksIncidentsQuestionsListName, filters: { TypeIncident: incTypes.security }, sortOrder: { name: 'Order0', asc: true } }).then((results) => {
                const tempIncQuestions = [...results.items];
                let incFieldsForm: any = [];
                incFieldsForm = [...incFieldsForm, ...[
                    {
                        type: 'dateRange',
                        require: false,
                        key: 'DateIncidents',
                        title: 'Дата несоответствия/инцидента',
                        placeholder: 'дд.мм.гггг',
                        isFilter: true,
                        condition: null,
                        width: 'w-full'
                    },
                    {
                        type: 'timeRange',
                        require: false,
                        key: 'TimeIncident',
                        isFilter: true,
                        title: 'Время несоответствия/инцидента',
                        placeholder: 'чч:мм',
                        condition: null,
                        width: 'w-full'
                    }
                ]];
                incFieldsForm = [...incFieldsForm, ...[
                    {
                        type: 'peoplePicker',
                        require: false,
                        single: true,
                        key: 'ResponsibleEmail',
                        title: 'ФИО инициатора',
                        isFilter: true,
                        condition: null,
                        placeholder: 'Введите имя или фамилию',
                        width: 'w-full'
                    },

                    {
                        type: 'checkbox',
                        require: false,
                        key: 'Location',
                        isFilter: true,
                        title: 'Локация, где произошло несоответствие/инцидент',
                        condition: null,
                        width: 'w-full'
                    },
                    {
                        type: 'checkbox',
                        require: false,
                        key: 'Department',
                        isFilter: true,
                        title: 'Отдел, где произошло несоответствие/инцидент',
                        condition: null,
                        width: 'w-full'
                    },
                    {
                        type: 'checkbox',
                        require: false,
                        key: 'Region',
                        isFilter: true,
                        title: 'Участок, где произошло несоответствие/инцидент',
                        condition: null,
                        width: 'w-full'
                    },
                    {
                        type: 'checkbox',
                        require: false,
                        key: 'Status',
                        isFilter: true,
                        title: 'Статус',
                        width: 'w-full'
                    },
                    {
                        type: 'checkbox',
                        require: false,
                        key: 'StatusActions',
                        isFilter: true,
                        title: 'Статус действий',
                        width: 'w-full',
                        optionsInputs: [
                            {
                                id: 1,
                                name: 'Нет действий',
                            },
                            {
                                id: 2,
                                name: 'В процессе',
                            },
                            {
                                id: 3,
                                name: 'Просрочено',
                            },
                            {
                                id: 4,
                                name: 'Отменено',
                            },
                            {
                                id: 5,
                                name: 'Закрыто'
                            },
                        ]

                    }
                ]];
                tempIncQuestions.forEach((item) => {
                    if (item.TypeQuestion === 'select') {
                        incFieldsForm = [...incFieldsForm, {
                            type: 'checkbox',
                            require: false,
                            key: item.Key,
                            title: item.Title,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            isFilter: true,
                            hide: item.DefaultHide,
                            width: 'w-full',
                            condition: item.Condition && JSON.parse(item.Condition),
                            optionsInputs: item.Options && item.Options.split(";").map((value: any) => {
                                return {
                                    id: value,
                                    name: value,
                                    disabled: false
                                }
                            })
                        }]
                    } else if (item.TypeQuestion === 'radio' || item.TypeQuestion === 'checkbox') {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: false,
                            key: item.Key,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            title: item.Title,
                            hide: item.DefaultHide,
                            width: 'w-full',
                            isFilter: true,
                            condition: item.Condition && JSON.parse(item.Condition),
                            optionsInputs: item.TypeQuestion === 'checkbox' && (item.Options && item.Options.split(";").map((value: any) => {
                                return {
                                    id: value,
                                    name: value,
                                    disabled: false
                                }
                            })) || (item.Options && item.Options.split(";").map(option => option.trim())) || []
                        }]
                    } else if (item.TypeQuestion === "number" || item.TypeQuestion === "input") {
                        incFieldsForm = [...incFieldsForm, {
                            type: 'numberRange',
                            require: false,
                            key: item.Key,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            title: item.Title,
                            isFilter: true,
                            hide: item.DefaultHide,
                            width: 'w-full',
                            condition: item.Condition && JSON.parse(item.Condition),
                        }]
                    } else if (item.TypeQuestion === "textArea") {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: false,
                            key: item.Key,
                            title: item.Title,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            disabled: item.Disabled,
                            placeholder: 'Введите значение',
                            hide: true,
                            width: item.Width,
                            condition: null,
                            default: item.Options
                        }]
                    }
                });
                incFieldsForm = [...incFieldsForm, {
                    type: 'dateRange',
                    require: false,
                    key: 'ClosedDate',
                    title: 'Срок на закрытие инцидента/несоответствия',
                    placeholder: 'дд.мм.гггг',
                    isFilter: true,
                    condition: null,
                    width: 'w-full'
                }]
                setIncQuestions([...incFieldsForm]);
            });
        }
    }, [currentTypeInc]);

    useEffect(() => {
        if (renderInc && incidentsFilter && Object.keys(incidentsFilter).length > 0) {
            let tempCurrentFromData = { ...incidentsFilter, ...{ TypeIncident: "Security" } }
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                const field = tempFieldsForm[i];
                if (field.condition) {
                    let conditionObj: any = {};
                    Object.keys(field.condition).map((key: string) => {
                        if (Array.isArray(tempCurrentFromData[key])) {
                            if (
                                tempCurrentFromData[key].some(
                                    (item) => item.name === field.condition[key]
                                )
                            ) {
                                conditionObj[key] = true;
                            }
                        } else if (typeof tempCurrentFromData[key] === "object") {
                            if (tempCurrentFromData[key] && tempCurrentFromData[key]["name"] && tempCurrentFromData[key]["name"] === field.condition[key]) {
                                conditionObj[key] = true;
                            }
                        } else {
                            if (tempCurrentFromData[key] === field.condition[key]) {
                                conditionObj[key] = true;
                            }
                        }
                    });
                    if (
                        Object.keys(field.condition).length ===
                        Object.keys(conditionObj).length
                    ) {
                        tempFieldsForm[i]["hide"] = false;
                    } else {
                        tempFieldsForm[i]["hide"] = true;
                    }
                }
            }
            let tempKeys: any = [];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                const field = tempFieldsForm[i];
                if (
                    !field.hide &&
                    (field.condition ||
                        field.key === "IncidentOption" ||
                        field.key === "QAIncidentType")
                ) {
                    tempKeys = [...tempKeys, field.key];
                }
            }
            setFields([...tempFieldsForm]);
            setIncKeys([...tempKeys]);
        }
    }, [incidentsFilter, renderInc]);

    useEffect(() => {
        if (userFilterCheck && collections.length > 0 && Object.keys(currentUser).length > 0 && currentUser.id > 0 && renderInc) {
            let defaultObj: any = {};
            const today = moment();
            const isMonday = today.isoWeekday() === 1;
            let defaultLocationsIds: number[] = [];
            if (Object.keys(filtersParams).length > 0) {
                Object.keys(filtersParams).forEach(key => {
                    if (filtersParams[key]) {
                        defaultObj[key] = filtersParams[key];
                    } else {
                        defaultObj[key] = null;
                    }
                });
                defaultObj['DateIncidents'] = incidentsFilter && incidentsFilter['DateIncidents'] || {
                    startDate: isMonday && moment().subtract(1, "weeks").startOf("week").format('YYYY-MM-DDT00:00:00') || moment().startOf("week").format('YYYY-MM-DDT00:00:00'),
                    endDate: isMonday && moment().subtract(1, "weeks").endOf("week").format('YYYY-MM-DDT23:59:59') || moment().endOf("week").format('YYYY-MM-DDT23:59:59')
                };
                // setIncidentsFilter({ ...filtersParams });
                setDefaultValues(defaultObj);
            } else if (defaultUserFilter && Object.keys(JSON.parse(defaultUserFilter.MTFullFilters)).length > 0) {
                Object.keys(JSON.parse(defaultUserFilter.MTFullFilters)).forEach(key => {
                    if (JSON.parse(defaultUserFilter.MTFullFilters)[key]) {
                        defaultObj[key] = JSON.parse(defaultUserFilter.MTFullFilters)[key];
                    } else {
                        defaultObj[key] = null;
                    }
                });
                defaultObj['DateIncidents'] = incidentsFilter && incidentsFilter['DateIncidents'] || {
                    startDate: isMonday && moment().subtract(1, "weeks").startOf("week").format('YYYY-MM-DDT00:00:00') || moment().startOf("week").format('YYYY-MM-DDT00:00:00'),
                    endDate: isMonday && moment().subtract(1, "weeks").endOf("week").format('YYYY-MM-DDT23:59:59') || moment().endOf("week").format('YYYY-MM-DDT23:59:59')
                };
                // setIncidentsFilter({ ...JSON.parse(defaultUserFilter.MTFullFilters) });
                setDefaultValues(defaultObj);
            } else {
                if (Object.keys(currentUser).length > 0 && (currentUser.isLocationAdminMyTasks || currentUser.isLocationEditorMyTasks)) {
                    if (Array.isArray(currentUser.isLocationAdminMyTasks) && currentUser.isLocationAdminMyTasks.length > 0) {
                        defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isLocationAdminMyTasks];
                    }
                    if (Array.isArray(currentUser.isLocationEditorMyTasks) && currentUser.isLocationEditorMyTasks.length > 0) {
                        defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isLocationEditorMyTasks];
                    }
                }
                let unicDefaultLocationsIds: number[] = [..._.uniqWith(defaultLocationsIds, _.isEqual)];
                setDependenceFields({
                    Location: unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
                        return { id: id, name: collections.find((collection: any) => collection.ID === id)['Title'], disabled: false }
                    }) || null,
                    Department: null,
                    Region: null
                });
                fields.map((field: any) => {
                    if (field.key === 'DateIncidents') {
                        defaultObj[field.key] = {
                            startDate: isMonday && moment().subtract(1, "weeks").startOf("week").format('YYYY-MM-DDT00:00:00') || moment().startOf("week").format('YYYY-MM-DDT00:00:00'),
                            endDate: isMonday && moment().subtract(1, "weeks").endOf("week").format('YYYY-MM-DDT23:59:59') || moment().endOf("week").format('YYYY-MM-DDT23:59:59')
                        }
                    } else if (field.key === "Location") {
                        defaultObj[field.key] = unicDefaultLocationsIds.length > 0 && unicDefaultLocationsIds.map(id => {
                            return { id: id, name: collections.find((collection: any) => collection.ID === id)['Title'], disabled: false }
                        }) || null;
                    } else {
                        defaultObj[field.key] = null
                    }
                })
                setDefaultValues(defaultObj);
            }
        }
    }, [resetFilters, renderInc, collections, JSON.stringify(currentUser), userFilterCheck, reRenderUserFilter]);

    useEffect(() => {
        if (renderInc) {
            if (searchQuery) {
                setFilters((prevState: any) => {
                    return { ...prevState, Description: `${searchQuery}*` };
                });
                setGegIncidents(false);
            } else if (!searchQuery && Object.keys(filters).length > 0 && filters["Description"]) {
                setFilters((prevState: any) => {
                    if (prevState && prevState.hasOwnProperty("Description")) {
                        delete prevState["Description"];
                        return { ...prevState };
                    } else {
                        return prevState;
                    }
                });
                setGegIncidents(false);
            }
        }
    }, [searchQuery, renderInc]);

    useEffect(() => {
        if (incKeys.length > 0) {
            const existsFiltersIncidents: any = {};
            Object.keys(incidentsFilter).map((key) => {
                if (incidentsFilter[key]) {
                    if (Array.isArray(incidentsFilter[key])) {
                        if (incidentsFilter[key].length > 0) {
                            existsFiltersIncidents[key] = incidentsFilter[key];
                        }
                    } else if (isObject(incidentsFilter[key])) {
                        if (Object.keys(incidentsFilter[key]).length > 0) {
                            existsFiltersIncidents[key] = incidentsFilter[key];
                        }
                    } else {
                        existsFiltersIncidents[key] = incidentsFilter[key];
                    }
                }
            });
            const tempFilters: any = {};
            const tempDisplayFilters: any = {};
            let tempIncidentsQuestions: any = [];
            let tempLocalIncidentsQuestions: any = {};
            console.log('existsFiltersIncidents: ', existsFiltersIncidents);
            Object.keys(existsFiltersIncidents).map((key) => {
                if (incKeys.some((incKey: string) => incKey === key) && key !== 'SecuritySafeCount' && key !== 'SecurityDamageCount' && key !== 'SecurityRisk') {
                    if (Array.isArray(existsFiltersIncidents[key])) {
                        if (existsFiltersIncidents[key].length > 0) {
                            if (existsFiltersIncidents[key].some(item => typeof item === 'object' && item.hasOwnProperty('name'))) {
                                existsFiltersIncidents[key].sort((a: any, b: any) => {
                                    return a.name.localeCompare(b.name);
                                });
                            } else {
                                existsFiltersIncidents[key].sort((a: any, b: any) => {
                                    return a.localeCompare(b);
                                });
                            }
                            tempLocalIncidentsQuestions = { ...tempLocalIncidentsQuestions, ...{ [key]: existsFiltersIncidents[key] } };
                            tempDisplayFilters[key] = existsFiltersIncidents[key].map((item => item.name || item));
                        }
                    } else {
                        tempIncidentsQuestions = [...tempIncidentsQuestions, `"${key}":${`"${existsFiltersIncidents[key]}"`}`];
                        tempDisplayFilters[key] = existsFiltersIncidents[key];
                    }
                } else if (key === "ClosedDate" || key === 'DateIncidents') {
                    tempFilters[key] = {
                        start: moment(existsFiltersIncidents[key].startDate).startOf('day').format('YYYY-MM-DDT00:00:00'),
                        end: moment(existsFiltersIncidents[key].endDate).endOf('day').format('YYYY-MM-DDT23:59:59'),
                    };
                    tempDisplayFilters[key] = `от ${moment(existsFiltersIncidents[key].startDate).format('DD.MM.YYYY')} до ${moment(existsFiltersIncidents[key].endDate).format('DD.MM.YYYY')}`;
                } else if (key === 'ResponsibleEmail') {
                    tempFilters[key] = `${existsFiltersIncidents[key][0]["value"]}*`;
                    tempDisplayFilters[key] = existsFiltersIncidents[key][0]["label"];
                } else if (key === "TimeIncident" || key === 'SecuritySafeCount' || key === 'SecurityDamageCount' || key === 'SecurityRisk' || key === 'StatusActions') {
                    tempLocalIncidentsQuestions = { ...tempLocalIncidentsQuestions, ...{ [key]: existsFiltersIncidents[key] } };
                    tempDisplayFilters[key] = existsFiltersIncidents[key];
                } else if (key === "Location" || key === "Department" || key === "Region" || key === 'Status') {
                    tempFilters[key] = existsFiltersIncidents[key].map((item: any) => item.id);
                    tempDisplayFilters[key] = existsFiltersIncidents[key].map((item: any) => item.name);
                }
                tempFilters['TypeIncident'] = incTypes.security;
            });
            setLocalFilters({ ...tempLocalIncidentsQuestions });
            if (tempIncidentsQuestions.length > 0) {
                tempFilters["Questions"] = tempIncidentsQuestions;
            }
            if (searchQuery) {
                tempFilters["Description"] = `${searchQuery}*`;
            }
            setFilters({ ...tempFilters });
            setDisplayFilters({ ...tempDisplayFilters });
            const tempExistsFiltersInc = { ...existsFiltersIncidents };
            tempExistsFiltersInc.hasOwnProperty('DateIncidents') && delete tempExistsFiltersInc['DateIncidents'];
            tempExistsFiltersInc.hasOwnProperty('TimeIncident') && delete tempExistsFiltersInc['TimeIncident'];
            if (JSON.stringify(filtersParams) !== JSON.stringify(tempExistsFiltersInc)) {
                setFiltersParams({ ...tempExistsFiltersInc });
            }
            setGegIncidents(false);
        }
    }, [incKeys]);

    return (
        <FlexCol className="relative">
            {incidentsFilter && Object.keys(incidentsFilter).length > 0 && (
                <div
                    onClick={() => {
                        setLocalFilters({});
                        setFilters({});
                        setDisplayFilters({});
                        setFiltersParams({});
                        setIncidentsFilter(null);
                        setResetFiters(!resetFilters);
                        setGegIncidents(false);
                    }}
                    className="p-5 flex flex-row group items-center text-[14px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap border-b"
                >
                    <div className="flex flex-col">Сбросить фильтры</div>
                    <div className="flex flex-col pt-1">
                        <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_33_4954)">
                                <path
                                    d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                                    fill="#637381"
                                ></path>
                            </g>
                            <defs>
                                <clipPath id="clip0_33_4954">
                                    <rect width="16" height="16" fill="white" transform="translate(0 12) rotate(-90)"></rect>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            )}
            {customLoading &&
                <LoadingOpBg />
            }
            <Form
                type="filter_my_tasks_inc"
                setFormData={setIncidentsFilter}
                fieldsForm={[...fields]}
                setCurrentTypeInc={setCurrentTypeInc}
                defaultValues={defaultValues}
                setDependenceFields={setDependenceFields}
            />
            {incidentsFilter && Object.keys(incidentsFilter).length > 0 && (
                <div
                    onClick={() => {
                        setLocalFilters({});
                        setFilters({});
                        setDisplayFilters({});
                        setFiltersParams({});
                        setIncidentsFilter(null);
                        setResetFiters(!resetFilters);
                        setGegIncidents(false);
                    }}
                    className="p-5 flex flex-row group items-center text-[12px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap"
                >
                    <div className="flex flex-col group-hover:underline">Сбросить фильтры</div>
                    <div className="flex flex-col pt-1">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_33_4954)">
                                <path
                                    d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                                    fill="#637381"
                                ></path>
                            </g>
                            <defs>
                                <clipPath id="clip0_33_4954">
                                    <rect width="12" height="12" fill="white" transform="translate(0 12) rotate(-90)"></rect>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            )}
        </FlexCol>
    );
}

export function SecurityPage() {
    const [exportData, setExportData] = useState<any>({});
    const [filters, setFilters] = useState<any>({});
    const [localFilters, setLocalFilters] = useState<any>({});
    const [searchQuery, setSearchQuery] = useState("");
    const [nextPage, setNextPage] = useState<any>(null);
    const [tempIncidents, setTempIncidents] = useState<any>([]);
    const [incidents, setIncidents] = useState<any>([]);
    const dispatch = useAppDispatch();
    const [customLoading, setCustomLoading] = useState(true);
    const [getIncidents, setGegIncidents] = useState(false)
    const location = useLocation();
    const statusUsers: string = useAppSelector((state: RootState) => state.users.status);
    const currentUser = useAppSelector((state) => selectCurrentUser(state));
    const statuses: any = useAppSelector((state) => selectItems(state, myTasksIncidentsStatusesListName));
    const [fieldsFromExel, setFieldsFromExel] = useState([]);
    const users: any = useAppSelector(selectUsers);

    function handleSearch(value: string) {
        setSearchQuery(value);
    }

    const [displayFilters, setDisplayFilters] = useState<any>({});
    const [displayFiltersStr, setDisplayFiltersStr] = useState<any>("");
    const [reRenderFilterSettings, setReRenderFilterSettings] = useState(false);
    const [filtersParams, setFiltersParams] = useState({});
    const [defaultUserFilter, setDefaultUserFilter] = useState<any>(null);
    const [userFilterCheck, setUserFilterCheck] = useState(false);
    const [reRenderUserFilter, setReRenderUserFilter] = useState(null);

    //Получение инцидентов после изменения фильтров
    useEffect(() => {
        console.log('filters: ', filters);
        if (!getIncidents && Object.keys(filters).length > 0) {
            setCustomLoading(true);
            setTempIncidents([]);
            setIncidents([]);
            getItemsRequest({
                listName: myTasksIncidentstListName,
                rowLimit: 25,
                filters,
                sortOrder: { name: "DateIncidents", desc: true },
            }).then((results: any) => {
                const { items, nextPage } = results;
                if (items.length > 0) {
                    let incIds: string[] = [];
                    let emails: any = [];
                    items.map((item: any) => {
                        incIds = [...incIds, `инцидент_security_${item.ID}*`];
                        if (item.ResponsibleEmail) {
                            emails = [...emails, item.ResponsibleEmail.toLowerCase()];
                        }
                        if (item.AuthorEmail) {
                            emails = [...emails, item.AuthorEmail.toLowerCase()];
                        }
                    });
                    dispatch(addUsers(emails));
                    getItemsRequest({
                        listName: myTaskActionsListName,
                        viewFields: ["ID", "Status", "Description", "ImportantHashTag"],
                        filters: { ImportantHashTag: incIds.length > 0 && incIds || ['0'] },
                    }).then((results) => {
                        let actions = [...results.items], actionsIncStatus: any = { name: 'В процессе', color: '#F2A900' };
                        let returnItems = items.map((item: any) => {
                            let currentActions: any = [];
                            currentActions = actions.filter(
                                (action: any) => action.ImportantHashTag && action.ImportantHashTag.trim() === `#инцидент_security_${item.ID}`.trim()
                            );
                            if (currentActions.length === 0) {
                                actionsIncStatus = { name: "Нет действий", color: "#FDE5D8" };
                            } else if (currentActions.length > 0 && currentActions.some((action: any) => action.Status.get_lookupId() === actionsStatus.old)
                            ) {
                                actionsIncStatus = { name: "Просрочено", color: "#F23030" };
                            } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.cancel).length === currentActions.length
                            ) {
                                actionsIncStatus = { name: "Отменено", color: "#6B7280" };
                            } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.closed).length === currentActions.length
                            ) {
                                actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                            } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.notStart).length === currentActions.length) {
                                actionsIncStatus = { name: "Не начато", color: "#FDE5D8" };
                            } else if (currentActions.length > 0 && (currentActions.some((action: any) => action.Status.get_lookupId() === actionsStatus.cancel) || currentActions.some((action: any) => action.Status.get_lookupId() === actionsStatus.closed)) && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.old).length === 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.process).length === 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.notStart).length === 0) {
                                actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                            } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.old).length === 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.process).length > 0
                            ) {
                                actionsIncStatus = { name: "В процессе", color: "#F2A900" };
                            }
                            return {
                                ...item,
                                tree: '-',
                                actions: currentActions,
                                actionsIncStatus
                            };
                        });
                        setTempIncidents([...returnItems]);
                        setGegIncidents(true);
                        if (items.length === 25) {
                            setNextPage(nextPage);
                        } else {
                            setNextPage(false);
                        }
                    });
                } else {
                    setTempIncidents([]);
                    setIncidents([]);
                    setGegIncidents(true);
                    setNextPage(null);
                }
            });
        }
    }, [filters]);

    //Получение инцидентов по nextPage
    useEffect(() => {
        if (nextPage && getIncidents) {
            setCustomLoading(true);
            setTempIncidents([]);
            setIncidents([]);
            getItemsRequest({
                listName: myTasksIncidentstListName,
                rowLimit: 25,
                filters,
                nextPage,
                sortOrder: { name: "DateIncidents", desc: true },
            }).then((results: any) => {
                const { items, nextPage } = results;
                let incIds: string[] = [];
                let emails: any = [];
                items.map((item: any) => {
                    incIds = [...incIds, `инцидент_security_${item.ID}*`];
                    if (item.ResponsibleEmail) {
                        emails = [...emails, item.ResponsibleEmail.toLowerCase()];
                    }
                    if (item.AuthorEmail) {
                        emails = [...emails, item.AuthorEmail.toLowerCase()];
                    }
                });
                dispatch(addUsers(emails));
                getItemsRequest({
                    listName: myTaskActionsListName,
                    viewFields: ["ID", "Status", "Description", "ImportantHashTag"],
                    filters: { ImportantHashTag: incIds.length > 0 && incIds || ['0'] },
                }).then((results) => {
                    let actions = [...results.items], actionsIncStatus: any = { name: 'В процессе', color: '#F2A900' };
                    let returnItems = items.map((item: any) => {
                        let currentActions: any = [];
                        currentActions = actions.filter(
                            (action: any) => action.ImportantHashTag && action.ImportantHashTag.trim() === `#инцидент_security_${item.ID}`.trim()
                        );
                        if (currentActions.length === 0) {
                            actionsIncStatus = { name: "Нет действий", color: "#FDE5D8" };
                        } else if (currentActions.length > 0 && currentActions.some((action: any) => action.Status.get_lookupId() === actionsStatus.old)
                        ) {
                            actionsIncStatus = { name: "Просрочено", color: "#F23030" };
                        } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.cancel).length === currentActions.length
                        ) {
                            actionsIncStatus = { name: "Отменено", color: "#6B7280" };
                        } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.closed).length === currentActions.length
                        ) {
                            actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                        } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.notStart).length === currentActions.length) {
                            actionsIncStatus = { name: "Не начато", color: "#FDE5D8" };
                        } else if (currentActions.length > 0 && (currentActions.some((action: any) => action.Status.get_lookupId() === actionsStatus.cancel) || currentActions.some((action: any) => action.Status.get_lookupId() === actionsStatus.closed)) && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.old).length === 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.process).length === 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.notStart).length === 0) {
                            actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                        } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.old).length === 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.process).length > 0
                        ) {
                            actionsIncStatus = { name: "В процессе", color: "#F2A900" };
                        }
                        return {
                            ...item,
                            tree: '-',
                            actions: currentActions,
                            actionsIncStatus
                        };
                    });
                    setTempIncidents((prevState: any) => [...prevState, ...returnItems]);
                    if (items.length === 25) {
                        setNextPage(nextPage);
                    } else {
                        setNextPage(false);
                    }
                });
            });
        }
    }, [nextPage]);

    useEffect(() => {
        if (tempIncidents.length > 0) {
            let incWithQuestions: any = [];
            tempIncidents.forEach((incItem: any) => {
                if (incItem.Questions) {
                    incWithQuestions = [...incWithQuestions, { ...incItem, ...JSON.parse(incItem.Questions) }];
                }
            });
            let localTempInc: any = [...incWithQuestions];
            if (Object.keys(localFilters).length > 0) {
                console.log('localFilters: ', localFilters);
                Object.keys(localFilters).forEach(key => {
                    if (key !== 'TimeIncident' && key !== 'StatusActions' && key !== 'SecuritySafeCount' && key !== 'SecurityDamageCount' && key !== 'SecurityRisk') {
                        localTempInc = localTempInc.filter((localInc: any) => {
                            if (Array.isArray(localFilters[key])) {
                                return localFilters[key].some((localFilter: any) => localInc.Questions && localInc.Questions.indexOf(localFilter.name.trim()) !== -1)
                            }
                        });
                    } else if (key === 'TimeIncident') {
                        localTempInc = localTempInc.filter((localItem: any) => localItem[key] && Number(localItem[key].replace(":", '')) > localFilters[key]['fromTime'] && Number(localItem.TimeIncident.replace(":", '')) < localFilters[key]['beforeTime']);
                    } else if (key === 'SecuritySafeCount' || key === 'SecurityDamageCount' || key === 'SecurityRisk') {
                        localTempInc = localTempInc.filter((localItem: any) => localItem.Questions && Number(JSON.parse(localItem.Questions)[key]) > localFilters[key]['fromNumber'] && localItem.Questions && Number(JSON.parse(localItem.Questions)[key]) < localFilters[key]['beforeNumber'])
                    } else if (key === 'StatusActions') {
                        localTempInc = localTempInc.filter((localInc: any) => {
                            if (Array.isArray(localFilters[key])) {
                                return localFilters[key].some((localFilter: any) => localFilter.name === localInc.actionsIncStatus.name)
                            }
                        });
                    }
                });
            }
            setIncidents([..._.uniqWith(localTempInc, _.isEqual)]);
        }
    }, [tempIncidents]);

    useEffect(() => {
        const incCardID = new URLSearchParams(location.search).get("securityCard");
        if (localStorage.getItem("NEW_INC") || localStorage.getItem('UPDATE_STATUS_INC')) {
            localStorage.setItem("NEW_INC", "");
            localStorage.setItem("UPDATE_STATUS_INC", "");
            setGegIncidents(false);
            setFilters({ ...filters });
        }
    }, [location]);

    useEffect(() => {
        if (!nextPage && getIncidents) {
            setCustomLoading(false);
        }
        console.log('incidents: ', incidents);
    }, [incidents]);

    useEffect(() => {
        let tempStr = "";
        Object.keys(displayFilters).map((key: string, idx: number) => {
            if (idx <= 3) {
                if (Array.isArray(displayFilters[key])) {
                    displayFilters[key].map((item: string, idx: number) => {
                        if (displayFilters[key].length - 1 === idx) {
                            tempStr += item
                        } else {
                            tempStr += `${item}, `
                        }
                    })
                } else {
                    tempStr += `${displayFilters[key]}`
                }
                tempStr += ', '
            }
        });
        tempStr = tempStr.slice(0, -2);
        if (Object.keys(displayFilters).length > 4) {
            tempStr += `...ещё ${Object.keys(displayFilters).length - 4}`
        }
        setDisplayFiltersStr(tempStr);
    }, [displayFilters]);

    return (
        <>
            {!users[currentUser.email] &&
                <></> ||
                (currentUser.isSecurityAdmin || currentUser.isSecurityEditor) &&
                <FlexRow className="scrollbar scrollbar-w-2 scrollbar-h-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] h-screen overflow-y-auto">
                    <FlexCol className="bg-white sticky-custom border-r w-80 text-[14px] text-[#8899A8] relative scrollbar scrollbar-w-2  scrollbar-h-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] max-h-screen">
                        <FlexCol className="max-w-[320px] overflow-y-auto scrollbar scrollbar-w-2 scrollbar-h-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB]">
                            <IncidentsFilters
                                filters={filters}
                                setGegIncidents={setGegIncidents}
                                setFilters={setFilters}
                                setSearchQuery={setSearchQuery}
                                searchQuery={searchQuery}
                                setLocalFilters={setLocalFilters}
                                setFieldsFromExel={setFieldsFromExel}
                                setDisplayFilters={setDisplayFilters}
                                filtersParams={filtersParams}
                                setFiltersParams={setFiltersParams}
                                defaultUserFilter={defaultUserFilter}
                                userFilterCheck={userFilterCheck}
                                reRenderUserFilter={reRenderUserFilter}
                            />
                        </FlexCol>
                    </FlexCol>
                    <FlexCol className="grow w-[calc(100%-320px)]">
                        <FlexCol className="w-full">
                            <FlexRow className="px-7.5 h-[76px] border-b justify-between items-center shrink-0">
                                <FlexCol>
                                    <nav className="flex justify-between w-full" aria-label="Breadcrumb">
                                        <FlexCol className="grow">
                                            <ol className="inline-flex items-center gap-2">
                                                <li className="inline-flex items-center" aria-current="page">
                                                    <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
                                                        <IncidentsSecurityIcon />
                                                        <span>Инциденты по Security</span>
                                                    </div>
                                                </li>
                                            </ol>
                                        </FlexCol>
                                    </nav>
                                </FlexCol>
                                <FlexRow className="items-center gap-2">
                                    <FavoriteButtonFilters filters={Object.keys(filters).length > 0 && JSON.stringify(filters) || ""} displayFilters={Object.keys(displayFilters).length > 0 && JSON.stringify(displayFilters) || ""} reRenderFilterSettings={reRenderFilterSettings} setReRenderFilterSettings={setReRenderFilterSettings} filtersParams={Object.keys(filtersParams).length > 0 && JSON.stringify(filtersParams) || ""} type="security" />
                                    <FavoriteFiltersList reRenderTableFlag={setGegIncidents} reRenderFilterSettings={reRenderFilterSettings} setReRenderFilterSettings={setReRenderFilterSettings} setFiltersParams={setFiltersParams} type="security" filtersParams={Object.keys(filtersParams).length > 0 && JSON.stringify(filtersParams) || ""} listQuestions={myTasksIncidentstWithRelationsListName} setDefaultUserFilter={setDefaultUserFilter} setUserFilterCheck={setUserFilterCheck} userFilterCheck={userFilterCheck} setReRenderUserFilter={setReRenderUserFilter} />
                                </FlexRow>
                            </FlexRow>
                            <FlexRow className="px-7.5 pt-3.5 pb-3.5 gap-x-2.5">
                                <FlexCol className="grow">
                                    <SearchUI placeholder={`Поиск по описанию инцидента`} defaultValue={searchQuery} onClick={handleSearch} />
                                </FlexCol>
                                {((customLoading) && (
                                    <FlexCol className="justify-center items-center gap-5">
                                        <Loading />
                                    </FlexCol>
                                )) || (
                                        <>
                                            {statusUsers === "LOADING" &&
                                                <FlexCol className="justify-center items-center gap-5">
                                                    <Loading />
                                                </FlexCol>
                                                ||
                                                <ExportToExcel exportData={exportData} fileName={"Инциденты по security"} type="my_tasks_incidents" />
                                            }
                                            {(currentUser.isSecurityAdmin || currentUser.isLocationEditorMyTasks || currentUser.isAdmin || currentUser.isLocationAdminMyTasks) &&
                                                <AddSecurity zIndex={70} />
                                            }
                                        </>
                                    )}
                            </FlexRow>
                            <FlexRow className="px-7.5">
                                <MyTasksSecurityTable
                                    data={incidents}
                                    setExportData={setExportData}
                                    customLoading={customLoading || statusUsers === "LOADING"}
                                    statuses={statuses}
                                    fieldsFromExel={fieldsFromExel}
                                />
                            </FlexRow>
                        </FlexCol>
                    </FlexCol>
                </FlexRow> ||
                <div className="text-center flex flex-col min-h-[80%] items-center justify-center"><div className="mb-[20px] font-medium text-[18px] text-[#111928]">У вас нет доступа к модулю Инциденты Security</div><div className="text-[14px] font-medium text-[#637381]">Пожалуйста, обратитесь к администратору</div></div>
            }
        </>
    );
}
